module.exports = __webpack_public_path__ + "img/2.933ddfb0.png";